'use client'
import { toggleMobileMenu } from "@/utlis/toggleMobileMenu";
import { useEffect, useState } from "react";
import Image from "next/image";
import useIsMobile from "@/app/api/useisMobile";
import Link from "next/link";

export default function ProductHeader({ data }) {
  const [selectedSolution, setSelectedSolution] = useState(null);
  const [menuOpen, setMenuOpen] = useState([-1, -1]);
  const [isHovered, setIsHovered] = useState({});
  const [selectedSubItem, setSelectedSubItem] = useState(null);

  const product = data[0];
  const solutionsData = product?.productFeatures || {};
  const resourcesData = product?.resources || [];
  const ProductsList = product?.ProductsList || [];
  const hrmssolutions = product?.hrmssolutions || [];


  const othermenus = product?.othermenus || [];

  const defaultLogo = "/assets/images/img/logo/getbiz_main_logo.webp";
  const defaultCtaButton = { name: "Get in touch", link: "/contactus/" };

  // Toggle menu state
  const toggleParent = (i) => {
    const tempMenuOpen = [...menuOpen];
    tempMenuOpen[0] = menuOpen[0] === i ? -1 : i;
    setMenuOpen(tempMenuOpen);
  };

  // Handle mouseover on solution
  const handleMouseOverSolution = (key) => {
    setSelectedSolution(solutionsData[key]);
    setSelectedSubItem(null);
  };

  // Handle mouseover on subitem
  const handleMouseOverSubItem = (subItem) => {
    setSelectedSubItem(subItem);
  };

  // Set default solution on mount
  useEffect(() => {
    if (Object.keys(solutionsData).length > 0) {
      setSelectedSolution(solutionsData[Object.keys(solutionsData)[0]]);
    }
  }, [solutionsData]);

  const isMobile = useIsMobile();
  const [isCRMSticky, setIsCRMSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsCRMSticky(true);
      } else {
        setIsCRMSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {!isMobile &&
        <nav className="main-nav transparent stick wch-unset"
          style={{
            background: isCRMSticky ? 'rgba(35, 35, 35)' : 'transparent',
            boxShadow: 'none',
            outline: 'none',
            position: isCRMSticky ? 'sticky' : 'fixed',
            top: isCRMSticky ? '0' : 'auto',
            width: '100%',
            height: '65px !important',
            zIndex: 1000,
          }}
        >
          <div className="main-nav-sub container">
            {/* Logo */}
            <div className="nav-logo-wrap position-static local-scroll">
              <a href={product?.productLink || "/crm-software/"} className="logo">
                <Image
                  src={product?.productLogo || defaultLogo} // Fallback to default logo
                  alt="getbiz Logo"
                  width={130}
                  height={40}
                  className="light-mode-logo rounded-md"
                />
              </a>
            </div>

            {/* Mobile Menu Button */}
            <div onClick={toggleMobileMenu} className="mobile-nav" role="button" tabIndex={0}>
              <i className="mobile-nav-icon" />
              <span className="visually-hidden">Menu</span>
            </div>

            {/* Main Menu */}
            <div className="inner-nav desktop-nav">
              <ul className="clearlist scroll-nav local-scroll justify-content-end items-end scrollspyLinks"
                style={{
                  height: '65px !important'
                }}
              >

                <li className={menuOpen[0] === 1 ? "js-opened" : ""}>
                  <a href="#" onClick={() => toggleParent(1)} className="mn-has-sub" aria-label="Features"
                    style={{
                      color: isCRMSticky ? 'white' : 'rgba(35, 35, 35)'
                    }}
                  >
                    Features <i className="mi-chevron-down" />
                  </a>
                  <ul className={`mn-sub mn-has-multi ${menuOpen[0] === 1 ? "mobile-sub-active" : ""}`}>
                    {/* Column 1 - Solutions */}
                    <li
                      className="mn-sub-multi"
                      style={{
                        minWidth: "250px",
                        marginLeft: "-30%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <ul>
                        {Object.keys(solutionsData).map((key, index) => (
                          <li
                            key={index}
                            onMouseOver={() => handleMouseOverSolution(key)}
                            onMouseEnter={() => setIsHovered((prev) => ({ ...prev, [key]: true }))}
                            onMouseLeave={() => setIsHovered((prev) => ({ ...prev, [key]: false }))}
                          >
                            <a href={`${solutionsData[key]?.link}` || '#'} aria-label={solutionsData[key]?.title}>
                              {solutionsData[key]?.title}
                              {isHovered[key] && (
                                <i
                                  className="mi-arrow-right items-end"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "18px",
                                    justifyContent: "flex-end",
                                  }}
                                />
                              )}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li>

                    {/* Column 2 - Selected Solution Subitems */}
                    <li
                      className="mn-sub-multi"
                      style={{
                        minWidth: "250px",
                        marginLeft: "-30%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <ul>
                        {selectedSolution?.subItems?.map((subItem, index) => (
                          <li key={index} onMouseOver={() => handleMouseOverSubItem(subItem)}>
                            <a href={subItem.link}>{subItem.title}</a>
                          </li>
                        ))}
                      </ul>
                    </li>
                  </ul>
                </li>

                {/* Resources */}
                {resourcesData.length > 0 && (
                  <li className={menuOpen[0] === 2 ? "js-opened" : ""}>
                    <a href="#" onClick={() => toggleParent(2)} className="mn-has-sub" aria-label="Resources">
                      Resources <i className="mi-chevron-down" />
                    </a>
                    <ul className={`mn-sub mn-has-multi ${menuOpen[0] === 2 ? "mobile-sub-active" : ""}`}>
                      <li className="mn-sub-multi" style={{ minWidth: "250px", marginLeft: "-30%", display: "flex", flexDirection: "column" }}>
                        <ul>
                          {resourcesData[0]?.subItems?.map((subItem, index) => (
                            <li key={index}>
                              <a href={subItem.link} aria-label={subItem.ariaLabel}>
                                {subItem.title}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </li>
                    </ul>
                  </li>
                )}

                {/* Solutions */}
                {hrmssolutions?.links?.length > 0 && (
                  <li className={menuOpen[0] === 4 ? "js-opened" : ""}>
                    <a
                      href="#"
                      onClick={() => toggleParent(4)}
                      className="mn-has-sub"
                      aria-label={hrmssolutions.title}
                      style={{ color: isCRMSticky ? 'white' : 'rgba(35, 35, 35)' }}>
                      {hrmssolutions.title} <i className="mi-chevron-down" />
                    </a>

                    <ul
                      className={`mn-sub mn-has-multi ${menuOpen[0] === 4 ? "mobile-sub-active" : ""
                        }`}
                    >
                      <li
                        className="mn-sub-multi"
                        style={{
                          minWidth: "250px",
                          marginLeft: "-30%",
                          display: "flex",
                          flexDirection: "column"
                        }}
                      >
                        <ul>
                          {hrmssolutions.links.map((linkItem, i) => (
                            <li key={i}>
                              <a href={linkItem.href}>{linkItem.text}</a>
                            </li>
                          ))}
                        </ul>
                      </li>
                    </ul>
                  </li>
                )}

                {/* CTA Button - Default fallback */}
                <li>
                  <a href={product?.cta?.ctaButtonLink || defaultCtaButton.link} className="opacity-1 no-hover">
                    <span
                      className={product?.cta?.ctaButtonClass || "btn btn-mod btn-color-light btn-border-white-light btn-small btn-circle"}
                      data-btn-animate="y"
                    >
                      {product?.cta?.ctaButtonName || defaultCtaButton.name} {/* Fallback to "Get in touch" */}
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav >
      }

      {/* Main Menu */}
      {isMobile &&
        <>
          <div className="inner-nav desktop-nav">
            <ul className="clearlist scroll-nav local-scroll justify-content-end items-end scrollspyLinks"
              style={{
                height: '65px !important'
              }}
            >

              <li className={menuOpen[0] === 1 ? "js-opened" : ""}>
                <a href="#" onClick={() => toggleParent(1)} className="mn-has-sub" aria-label="Features"                  >
                  Features <i className="mi-chevron-down" />
                </a>
                <ul className={`mn-sub mn-has-multi ${menuOpen[0] === 1 ? "mobile-sub-active" : ""}`}>
                  {/* Column 1 - Solutions */}
                  <li
                    className="mn-sub-multi"
                    style={{
                      minWidth: "250px",
                      marginLeft: "-30%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <ul>
                      {Object.keys(solutionsData).map((key, index) => (
                        <li
                          key={index}
                          onMouseOver={() => handleMouseOverSolution(key)}
                          onMouseEnter={() => setIsHovered((prev) => ({ ...prev, [key]: true }))}
                          onMouseLeave={() => setIsHovered((prev) => ({ ...prev, [key]: false }))}
                        >
                          <a href={`${solutionsData[key]?.link}` || '#'} aria-label={solutionsData[key]?.title}>
                            {solutionsData[key]?.title}
                            {isHovered[key] && (
                              <i
                                className="mi-arrow-right items-end"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "18px",
                                  justifyContent: "flex-end",
                                }}
                              />
                            )}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </li>

                  {/* Column 2 - Selected Solution Subitems */}
                  <li
                    className="mn-sub-multi"
                    style={{
                      minWidth: "250px",
                      marginLeft: "-30%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <ul
                      style={isMobile ? { marginLeft: "25px" } : {}}
                    >
                      {selectedSolution?.subItems?.map((subItem, index) => (
                        <li key={index} onMouseOver={() => handleMouseOverSubItem(subItem)}>
                          <a href={subItem.link}>{subItem.title}</a>
                        </li>
                      ))}
                    </ul>
                  </li>
                </ul>
              </li>
              {/* Resources */}
              {resourcesData.length > 0 && (
                <li className={menuOpen[0] === 2 ? "js-opened" : ""}>
                  <a href="#" onClick={() => toggleParent(2)} className="mn-has-sub" aria-label="Resources">
                    Resources <i className="mi-chevron-down" />
                  </a>
                  <ul className={`mn-sub mn-has-multi ${menuOpen[0] === 2 ? "mobile-sub-active" : ""}`}>
                    <li className="mn-sub-multi" style={{ minWidth: "250px", marginLeft: "-30%", display: "flex", flexDirection: "column" }}>
                      <ul>
                        {resourcesData[0]?.subItems?.map((subItem, index) => (
                          <li key={index}>
                            <a href={subItem.link} aria-label={subItem.ariaLabel}>
                              {subItem.title}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li>
                  </ul>
                </li>
              )}

              {/* Solutions */}
              {hrmssolutions?.links?.length > 0 && (
                <li className={menuOpen[0] === 4 ? "js-opened" : ""}>
                  <a
                    href="#"
                    onClick={() => toggleParent(4)}
                    className="mn-has-sub"
                    aria-label={hrmssolutions.title}
                  >
                    {hrmssolutions.title} <i className="mi-chevron-down" />
                  </a>

                  <ul
                    className={`mn-sub mn-has-multi ${menuOpen[0] === 4 ? "mobile-sub-active" : ""
                      }`}
                  >
                    <li
                      className="mn-sub-multi"
                      style={{
                        minWidth: "250px",
                        marginLeft: "-30%",
                        display: "flex",
                        flexDirection: "column"
                      }}
                    >
                      <ul>
                        {hrmssolutions.links.map((linkItem, i) => (
                          <li key={i}>
                            <Link href={linkItem.href}>{linkItem.text}</Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                  </ul>
                </li>
              )}

              {/* Product */}
              {ProductsList.length > 0 && <li className={menuOpen[0] === 3 ? "js-opened" : ""}>
                <a href="#" onClick={() => toggleParent(3)} className="mn-has-sub" aria-label="Resources">
                  Product <i className="mi-chevron-down" />
                </a>
                <ul className={`mn-sub mn-has-multi ${menuOpen[0] === 3 ? "mobile-sub-active" : ""}`}>
                  <li className="mn-sub-multi" style={{ minWidth: "250px", marginLeft: "-30%", display: "flex", flexDirection: "column" }}>
                    <ul>
                      {ProductsList.map((product, index) => (
                        <li key={index}>
                          <a href={product.link}>{product.title}</a>
                        </li>
                      ))}
                    </ul>
                  </li>
                </ul>
              </li>}

              {/* {othermenus.length > 0 &&
                <li className={menuOpen[0] === 4 ? "js-opened" : ""}>
                  <a
                    href="#"
                    onClick={() => toggleParent(4)}
                    className="mn-has-sub"
                    aria-label={item.title}
                  >
                    {item.title} <i className="mi-chevron-down" />
                  </a>

                  {item.subMenu && (
                    <ul
                      className={`mn-sub mn-has-multi ${menuOpen[0] === 4 ? "mobile-sub-active" : ""
                        }`}
                    >
                      {item.subMenu.map((column, columnIdx) => (
                        <li
                          className="mn-sub-multi"
                          key={columnIdx}
                          style={{
                            minWidth: "250px",
                            marginLeft: "-30%",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <ul>
                            {column.links.map((link, linkIdx) => (
                              <li key={linkIdx}>
                                <a href={link.href}>
                                  {link.icon && <i className={link.icon}></i>} {link.text}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>} */}

              {/* CTA Button - Default fallback */}
              <li>
                <a href={product?.cta?.ctaButtonLink || defaultCtaButton.link} className="opacity-1 no-hover">
                  <span
                    className={product?.cta?.ctaButtonClass || "btn btn-mod btn-color-light btn-border-white-light btn-small btn-circle"}
                    data-btn-animate="y"
                  >
                    {product?.cta?.ctaButtonName || defaultCtaButton.name} {/* Fallback to "Get in touch" */}
                  </span>
                </a>
              </li>
            </ul>

          </div>

        </>
      }
    </>

  );
}
